import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-star",
  "use": "icon-star-usage",
  "viewBox": "0 0 6 6",
  "content": "<symbol viewBox=\"0 0 6 6\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-star\">\r\n<path d=\"M2.21714 5.21784L3.35474 3.84984L4.49234 5.21784L5.12594 4.75704L4.20434 3.25944L5.77394 2.61144L5.52914 1.87704L3.88754 2.26584L3.74354 0.537842H2.96594L2.82194 2.28024L1.18034 1.87704L0.921143 2.61144L2.49074 3.25944L1.58354 4.75704L2.21714 5.21784Z\" fill=\"#F56C6C\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/star.svg
// module id = 60zo
// module chunks = 19